export default __webpack_public_path__ + "static/media/Send.cd234106.svg";